export const SITE_TYPE = {
  ALL: 0,
  THROO: 1,
  BEHIND: 2,
  NONE: 99,
};
export const APP_TYPE = {
  WEB: 0,
  POS: 1,
  TABLEORDER: 2,
  KIOSK: 3,
  DID: 4,
  KNOCKKNOCK: 8,
  KNOCKPOS: 9,
  KNOCKWEB: 10,
};
export const DELIVERY_POINTS = 50;
export const DELIVERY_WITHDRAW_MIN = 10000;

/**
 * 주문대기
 */
export const ORDER_WAIT_STATUS = 0;

/**
 * 주문접수
 */
export const ORDER_READY_STATUS = 1;

/**
 * 조리완료
 */
export const ORDER_COM_COOK_STATUS = 2;

/**
 * 배달시작
 */
export const ORDER_START_DEL_STATUS = 6;

/**
 * 배달완료
 */
export const ORDER_COM_DEL_STATUS = 7;

/**
 * 서빙완료
 */
export const ORDER_COM_SERVING_STATUS = 3;

/**
 * 주문완료
 */
export const ORDER_COM_STATUS = 5;

/**
 * 주문취소
 */
export const ORDER_CANCLE_STATUS = 4;

// knockknock
export const APP_NAME_KNOCKKNOCK = 'KNOCK';
export const APP_NAME_THROO = 'THROO';

export const THROO_ORDER_STATE_COLOR = {
  STANDBY: 'standby',
  CONFIRMED: 'confirmed',
  PREPARED: 'prepared',
  CONCLUDE: 'conclude',
  CUSTOMER_CANCELLED: 'customer_cancelled',
  STORE_CANCELLED: 'store_cancelled',
};

export type DropdownType = {
  key: number;
  label: string;
  name: string;
  value: number;
};
